import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useSunglassesProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import '../../ClickAndReserve/context/ClickAndReserveGlobalContext/ClickAndReserveGlobalContext.js';
import '@grandvisionhq/common';
import '@grandvisionhq/state';
import '@grandvisionhq/stores-v2';
import '../../../types/product.js';
import '@swc/helpers';
import '@grandvisionhq/analytics';
import '@grandvisionhq/iris-ui';
import ClickAndReserveContainer from '../../ClickAndReserve/components/ClickAndReserveContainer.js';
import '@grandvisionhq/forms';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import { MultiFacetPicker } from '../components/FacetPickerContainers/MultiFacetPicker/MultiFacetPicker.js';
import { useEcommFacetContext } from '../context/EcommFacetContext.js';
import '@grandvisionhq/inventory';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/lib-utils-html';
import '../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../hooks/useCartDiscounts/types.js';
import '../../../operations/queries/get-accessories-by-slug.js';
import '../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../operations/queries/get-frames-by-slug.js';
import '../../../operations/queries/get-solutions-by-slug.js';
import '../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../hooks/use-product-view-history.js';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import '@grandvisionhq/content';
import { SunglassesCTA } from './components/SunglassesCTA/SunglassesCTA.js';
import { SunglassesPriceSection } from './components/SunglassesPriceSection/SunglassesPriceSection.js';
import { SunglassesRxableSelectContainer } from './components/SunglassesRxableSelect/SunglassesRxableSelectContainer.js';
import { useSunglassesEcommContext } from './context/SunglassesEcommContext.js';

const SunglassesEcommContent = ({ className , ctaRef  })=>{
    const { activeVariant: { displayName , sku: activeSku , isExcludedFromCheckout  } , product ,  } = useSunglassesProductData();
    const { isValid , setNotificationType  } = useEcommFacetContext();
    const triggerAlertMessage = ()=>setNotificationType('error')
    ;
    const { handleConfiguratorClose , isConfiguratorOpen , shouldOpenConfigurator  } = useSunglassesEcommContext();
    const { isOfferedWithPrescriptions  } = product;
    const { Slots  } = useProductDetailSlots();
    return /*#__PURE__*/ React.createElement("section", {
        "aria-label": displayName,
        className: classnames('sunglasses-ecomm-content', className)
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        className: "sunglasses-ecomm-content__tag"
    }), /*#__PURE__*/ React.createElement(SunglassesPriceSection, null), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(MultiFacetPicker, {
        showStockIndicator: !isExcludedFromCheckout
    }, isOfferedWithPrescriptions && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SunglassesRxableSelectContainer, null), /*#__PURE__*/ React.createElement(Hr, null))), /*#__PURE__*/ React.createElement("div", {
        className: "sunglasses-ecomm-content__column"
    }, Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        isExcludedFromCheckout: isExcludedFromCheckout,
        deliveryItems: [
            {
                sku: activeSku,
                quantity: 1
            }
        ],
        withRxLens: shouldOpenConfigurator,
        className: "sunglasses-ecomm-content__delivery-indicator"
    }) : null, /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, /*#__PURE__*/ React.createElement(SunglassesCTA, null)), /*#__PURE__*/ React.createElement(ClickAndReserveContainer, {
        sku: activeSku,
        onInvalidClick: !isValid ? triggerAlertMessage : undefined
    }), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), Slots.Configurator && /*#__PURE__*/ React.createElement(Slots.Configurator, {
        id: "rxSun",
        onModalClose: handleConfiguratorClose,
        isOpen: isConfiguratorOpen
    }));
};

export { SunglassesEcommContent };
//# sourceMappingURL=SunglassesEcommContent.js.map
